import { render, staticRenderFns } from "./EditarNotificacion.vue?vue&type=template&id=59038f87&"
import script from "./EditarNotificacion.vue?vue&type=script&lang=js&"
export * from "./EditarNotificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports